import * as History from 'history'
import * as Redux from 'redux'
import * as Router from 'universal-router'
import * as Constants from './constants'

export interface RasaRouterContext extends History.LocationDescriptorObject {
  store: Redux.Store<any>
  route: Router.Route
}
export type OnEnterMiddleWare = Router.ResolveRoute<RasaRouterContext>
export interface OnEnterAction extends Redux.Action {
  params: Router.QueryParams,
  pathname: string,
}
export const onEnterMiddleware: OnEnterMiddleWare = (routerContext, params) => {
  const {store, path, route} = routerContext
  if (path) {
    store.dispatch({type: Constants.ON_ENTER, pathname: path, params})
    return route.action(routerContext, params)
  }
}
